import React from 'react';

import { Box } from '@mui/material';

import { getInsertionCursorPaddingLeft } from './helpers/paddingCalculators';

type Props = {
  position: 'before' | 'after';
  blockId: string;
  overBlockStatus: null | {
    id: string;
    position: 'before' | 'after';
  };
  depth: number;
};

export default function InsertionCursor({ blockId, position, overBlockStatus, depth }: Props) {
  if (!overBlockStatus) {
    return null;
  }
  if (overBlockStatus.id !== blockId) {
    return null;
  }
  if (overBlockStatus.position !== position) {
    return null;
  }
  return (
    <Box position="relative">
      <Box
        sx={{
          position: 'absolute',
          backgroundColor: '#4c9ffe',
          height: '2px',
          left: getInsertionCursorPaddingLeft(depth),
          right: 24,
        }}
      />
    </Box>
  );
}
